import {
  Bell,
  Pulse,
  Buildings,
  FadersHorizontal,
  type Icon,
  ShieldCheck,
  Stack,
  Tag,
  UserCircle,
  UsersThree,
} from "@phosphor-icons/react";
import { ROUTES } from "@/app/routes";

export type SettingsNavigationGroup = "settings.groups.account" | "settings.groups.organization";

export const SETTINGS_NAVIGATION_GROUPS: SettingsNavigationGroup[] = [
  "settings.groups.account",
  "settings.groups.organization",
];

export const SETTINGS_NAVIGATION = [
  {
    label: "settings.nav.profile",
    path: ROUTES.PROFILE,
    icon: UserCircle,
    group: "settings.groups.account",
  },
  {
    label: "settings.nav.memberships",
    path: ROUTES.ORGANIZATION.MEMBERSHIPS,
    icon: Stack,
    group: "settings.groups.account",
  },
  {
    label: "settings.nav.preferences",
    path: ROUTES.PREFERENCES,
    icon: FadersHorizontal,
    group: "settings.groups.account",
  },
  {
    label: "settings.nav.notifications",
    path: ROUTES.NOTIFICATIONS,
    icon: Bell,
    group: "settings.groups.account",
  },
  {
    label: "settings.nav.security",
    path: ROUTES.SECURITY,
    icon: ShieldCheck,
    group: "settings.groups.account",
  },
  {
    label: "settings.nav.general",
    path: ROUTES.ORGANIZATION.GENERAL,
    icon: Buildings,
    group: "settings.groups.organization",
  },
  {
    label: "settings.nav.members",
    path: ROUTES.ORGANIZATION.USERS,
    icon: UsersThree,
    group: "settings.groups.organization",
  },
  {
    label: "settings.nav.tags",
    path: ROUTES.ORGANIZATION.TAGS,
    icon: Tag,
    group: "settings.groups.organization",
  },
  {
    label: "activity.title",
    path: ROUTES.ORGANIZATION.ACTIVITY,
    icon: Pulse,
    group: "settings.groups.organization",
  },
] as const satisfies readonly {
  label: string;
  path: string;
  icon: Icon;
  group: SettingsNavigationGroup;
}[];

export const SETTINGS_ROUTES = SETTINGS_NAVIGATION.map(({ path, label }) => ({ path, label }));
